import { back } from './styles.css';

export interface HeaderBackProps {
  onClick?: () => void;
}

export const HeaderBack = (props: HeaderBackProps) => {
  const { onClick } = props;

  return (
    <button type="button" className={back} onClick={onClick}>
      <svg
        width="10"
        height="18"
        viewBox="0 0 10 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 17L1 9L9 1"
          stroke="#404040"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
